<template>
  <div>
    <section>
      <h1>Replace Contact Forms</h1>
      <div>
        <button class="is-primary" @click="convertAll">
          Start Conversion
        </button>
      </div>

      <div v-if="converting">
        <p>Company {{ companiesConverted }}/{{ companies.length }} Converted</p>
      </div>

      <div>
        <ul>
          <li v-for="site in sitesConverted" :key="site.id">{{ site }}</li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
import page from '@/mixins/page'
import pagination from '@/mixins/pagination'

import {readCompaniesData} from '@/lib/companies'
import {readCompanySitesData} from '@/lib/sites'
import {readCompanySitePagesData} from '@/lib/pages'
import {createCompanySitePageListData} from '@/lib/lists'
import {createCompanySitePageListListItemData} from '@/lib/list_items'

import {readListTypesData} from '@/lib/list_types'

export default {
  name: 'replace-contact-pages',

  mixins: [page, pagination],

  data() {
    return {
      converting: false,
      companiesConverted: 0,
      success: false,
      steppingThrough: false,
      companies: [],
      sitesConverted: [],
      company: {},
      site: {},
      selectedSite: {},
      siteId: '',
      sites: [],
      page: {},
      list: {},
      lists: [],
      listTypes: [],
      errors: {},
      siteGalleries: [],
      galleryId: '',
      basicGalleryId: ''
    }
  },

  computed: {
    simpleFormId() {
      return this.listTypes.find((type) => type.name === 'simple-form').id
    }
  },

  methods: {
    getData() {
      readCompaniesData({page: 1, page_size: 250}).then(({data, page}) => {
        this.companies = data
        this.pageData = page
      })

      readListTypesData().then(({data}) => {
        this.listTypes = data
      })
    },

    convertAll() {
      this.converting = true

      this.companies.forEach((company, index) => {
        window.setTimeout(() => {
          this.getSites(company.id)
          this.companiesConverted++
        }, 1000 * index)
      })
    },

    getSites(companyId) {
      readCompanySitesData(companyId, {page: 1, page_size: 250}).then(
        ({data}) => {
          let sites = data

          if (sites.length) {
            sites.forEach((site, index) => {
              window.setTimeout(() => {
                this.handleContactConversion(companyId, site.id, site)
                this.siteId = site.id
              }, 1000 * index)
            })
          }
        }
      )
    },

    createSimpleForm(companyId, siteId, pageId, site) {
      let list = {
        name: 'Contact Form',
        list_type_id: this.simpleFormId,
        weight: 5
      }

      createCompanySitePageListData(
        companyId,
        siteId,
        pageId,
        list
      ).then(({data}) => {
        let createdList = data

        let listItem = {
          key: 'Message field',
          value: `{"label":"Your Message","field_type":"form-textarea"}`,
          weight: 1
        }

        createCompanySitePageListListItemData(
          companyId,
          siteId,
          pageId,
          createdList.id,
          listItem
        ).then(() => {
          this.sitesConverted.push(site.name)
        })
      })
    },

    handleContactConversion(companyId, siteId, site) {
      readCompanySitePagesData(companyId, siteId, site).then(({data}) => {
        let pages = data

        let contactPage = pages.find(page => page.path === '/contact')

        if (contactPage) {
          this.createSimpleForm(companyId, siteId, contactPage.id, site)
        }
      })
    }
  },

  mounted() {
    this.getData()
  }
}
</script>

<style lang="sass"></style>
